export var DifficultyLevel;
(function (DifficultyLevel) {
    DifficultyLevel["Easy"] = "Easy";
    DifficultyLevel["Medium"] = "Medium";
    DifficultyLevel["Hard"] = "Hard";
    DifficultyLevel["Expert"] = "Expert";
})(DifficultyLevel || (DifficultyLevel = {}));
export function toGameId(id) {
    return id;
}
